import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DataFieldSection } from '~/features/data-fields/types';

interface State {
  action:
    | 'add'
    | 'reorder'
    | 'delete'
    | 'rename'
    | 'add-field'
    | 'delete-field'
    | 'edit-field'
    | 'move-field'
    | null;
  sections: DataFieldSection[];
  selectedSection: DataFieldSection | null;
  selectedField: any | null;
}

const initialState: State = {
  action: null,
  sections: [],
  selectedSection: null,
  selectedField: null,
};

export default createSlice({
  name: 'Data Fields',
  initialState,
  selectors: {
    selectAction: (state) => state.action,
    selectSections: (state) => state.sections,
    selectedSection: (state) => state.selectedSection,
    selectedField: (state) => state.selectedField,
  },
  reducers: {
    setAction: (
      state: State,
      action: PayloadAction<State['action'] | null>,
    ) => {
      state.action = action.payload;
    },

    setSections: (state: State, action: PayloadAction<State['sections']>) => {
      state.sections = action.payload;
    },

    setSection: (state: State, action: PayloadAction<DataFieldSection>) => {
      state.selectedSection = action.payload;
    },

    setField: (state: State, action: PayloadAction<any>) => {
      state.selectedField = action.payload;
    },

    resetAction: (state: State) => {
      state.action = initialState.action;
    },

    resetConfiguration: (state: State) => {
      state.action = initialState.action;
      state.selectedSection = initialState.selectedSection;
      state.selectedField = initialState.selectedField;
    },
  },
});
